import { boot } from "@origin-digital/bootloader";
import { configFetch } from "@origin-digital/daxi";
import { initHandler } from "@origin-digital/mesh";
import { EnvironmentNames } from "@origin-digital/platform-enums";
import { isNative as verifyIsNative } from "@origin-digital/platform-helpers";

const environment = window.oetal.env.name as EnvironmentNames;
const isSSR = window.oetal.ssr.onServer;
const { retail, authenticated = false } = window.oetal.pageData;

const disableAuthCheck = ["local", "dev"].includes(environment);
const isNative = verifyIsNative();

// init mesh here
initHandler({
  isNative,
  environment
});

configFetch({
  environment: environment as any,
  disableAuthCheck
});

boot({
  authenticated,
  retail,
  isNative,
  isSSR,
  environment
});
